import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const useLeftMenuStyle = (show: boolean) => {
  const { palette } = useCustomTheme();
  const [mousePosition, setMousePosition] = useState({ x: 0 });

  const mouseOverHiddenMenu = mousePosition.x < 22;

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePosition({
        x: event.clientX,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const useStyles = makeStyles({
    root: {
      left: show ? 0 : 96,
      '&::WebkitScrollbar': {
        display: 'none',
      },
      ...(!show && mouseOverHiddenMenu
        ? {
            transition: 'all 0.1s ease!important',
            '&:hover': {
              backgroundColor: `${palette.grey[100]}!important`,
            },
          }
        : {}),
    },
    nested: {
      transition: '0.1s ease',
      backgroundColor: !show && mouseOverHiddenMenu ? palette.grey[100] : palette.grey[50],
      color: !show && mouseOverHiddenMenu ? palette.grey[900] : palette.getContrastText(palette.grey[50]),
    },
    button: {
      '&:hover': {
        backgroundColor: show ? palette.grey[100] : palette.grey[50],
      },
    },
  });

  const classes = useStyles();

  return { classes };
};
